// extracted by mini-css-extract-plugin
module.exports = {"button":"StyledButton_button__Ijo36","icon":"StyledButton_icon__1hctP","text":"StyledButton_text__CpJzL"};